import { lazy } from 'react';
import { pageUrl } from '../services/pageUrl';

export const administration_routes = [
  // #########################################################################################
  // #############                ADMINISTRATION                   ###########################
  // #########################################################################################
  // Categories
  {
    exact: true,
    path: pageUrl.administration.settings.category,
    component: lazy(() =>
      import('../views/menu/administration/admin/category/table')
    ),
  },
  {
    exact: true,
    path: '/category/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/category/fiche/ViewHandler')
    ),
  },
  {
    exact: true,
    path: '/category/detail/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/category/fiche/ViewHandler')
    ),
  },
  {
    exact: true,
    path: '/category/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/category/fiche/NewView')
    ),
  },

  // Labels
  {
    exact: true,
    path: pageUrl.administration.settings.label,
    component: lazy(() =>
      import('../views/menu/administration/admin/label/table')
    ),
  },
  {
    exact: true,
    path: '/label/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/label/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/label/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/label/fiche/index')
    ),
  },
  // Perimetre
  {
    exact: true,
    path: pageUrl.administration.settings.perimeter,
    component: lazy(() =>
      import('../views/menu/administration/admin/perimetre/table')
    ),
  },
  {
    exact: true,
    path: '/perimeter/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/perimetre/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/perimeter/detail/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/perimetre/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/perimeter/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/perimetre/fiche/index')
    ),
  },
  // Banques
  {
    exact: true,
    path: pageUrl.administration.settings.banque,
    component: lazy(() =>
      import('../views/menu/administration/admin/banque/table')
    ),
  },
  {
    exact: true,
    path: '/bank/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/banque/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bank/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/banque/fiche/index')
    ),
  },

  // Filiales (entites)
  {
    exact: true,
    path: pageUrl.administration.settings.entity,
    component: lazy(() =>
      import('../views/menu/administration/admin/filiale/table')
    ),
  },

  {
    exact: true,
    path: '/filiale/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/filiale/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/filiale/detail/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/filiale/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/filiale/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/filiale/fiche/index')
    ),
  },

  // Parametrages
  {
    exact: true,
    path: pageUrl.administration.settings.groupSettings,
    component: lazy(() =>
      import('../views/menu/administration/admin/settings/liste')
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.settings.eyesSettings,
    component: lazy(() =>
      import('../views/menu/administration/admin/settings/4yeux/table')
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.settings.group,
    component: lazy(() =>
      import('../views/menu/administration/admin/settings/groupe')
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.settings.mobile,
    component: lazy(() =>
      import('../views/menu/administration/admin/settings/mobile')
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.settings.security,
    component: lazy(() =>
      import('../views/menu/administration/admin/settings/securite')
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.settings.signature,
    component: lazy(() =>
      import('../views/menu/administration/admin/settings/signature')
    ),
  },
  /// Relevés de compte
  {
    exact: true,
    path: pageUrl.administration.settings.statement,
    component: lazy(() =>
      import('../views/menu/administration/admin/account_statement/table/index')
    ),
  },
  {
    exact: true,
    path: '/admin_statement/details/:account_id',
    component: lazy(() =>
      import('../views/menu/administration/admin/account_statement/detail/index')
    ),
  },
  {
    exact: true,
    path: '/admin_statement/new_day_time/:account_id',
    component: lazy(() =>
      import('../views/menu/administration/admin/account_statement/new-day-time/index')
    ),
  },
  {
    exact: true,
    path: "/admin_statement/accounts_unknown",
    component: lazy(() =>
      import('../views/menu/administration/admin/account_statement/accountInconnue/index')
    ),
  },

  // Regles de relevé 

  {
    exact: true,
    path: pageUrl.administration.settings.rules_statement,
    component: lazy(() =>
      import('../views/menu/administration/admin/rules_statement/table/index')
    ),
  },

  {
    exact: true,
    path: "/frm_Rlv_Regle/new",
    component: lazy(() =>
      import('../views/menu/administration/admin/rules_statement/fiche/index')
    ),
  },

  {
    exact: true,
    path: "/frm_Rlv_Regle/edit/:id",
    component: lazy(() =>
      import('../views/menu/administration/admin/rules_statement/fiche/index')
    ),
  },

  /// GroupeTreasury

  {
    exact: true,
    path: pageUrl.administration.settings.treasuryGroup,
    component: lazy(() =>
      import('../views/menu/administration/admin/groupetreasury/table')
    ),
  },

  {
    exact: true,
    path: '/treasury_profile/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/groupetreasury/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/treasury_profile/detail/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/groupetreasury/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/treasury_profile/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/groupetreasury/fiche/index')
    ),
  },

  // smartTag
  {
    exact: true,
    path: pageUrl.administration.settings.smartTag,
    component: lazy(() =>
      import('../views/menu/administration/admin/smarttag/table/index')
    ),
  },
  {
    exact: true,
    path: '/smarttag/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/smarttag/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/smarttag/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/smarttag/fiche/index')
    ),
  },

  // smartTag
  {
    exact: true,
    path: pageUrl.administration.settings.bankHoliday,
    component: lazy(() =>
      import('../views/menu/administration/admin/bank_holidays/table/index')
    ),
  },
  // Utilisateurs (user)
  {
    exact: true,
    path: pageUrl.administration.settings.user,
    component: lazy(() =>
      import('../views/menu/administration/admin/user/table/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.administration.settings.user}/new`,
    component: lazy(() =>
      import('../views/menu/administration/admin/user/fiche/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.administration.settings.user}/edit/:id`,
    component: lazy(() =>
      import('../views/menu/administration/admin/user/fiche/index')
    ),
  },
  // Groupe Utilisateurs (groupuser)
  {
    exact: true,
    path: pageUrl.administration.settings.administratorGroup,
    component: lazy(() =>
      import('../views/menu/administration/admin/groupadmins/table')
    ),
  },
  {
    exact: true,
    path: '/group-admin/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/groupadmins/fiche')
    ),
  },
  {
    exact: true,
    path: '/group-admin/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/groupadmins/fiche')
    ),
  },
  // Jobs
  {
    exact: true,
    path: pageUrl.administration.settings.jobs,
    component: lazy(() =>
      import('../views/menu/administration/admin/jobs/table')
    ),
  },
  {
    exact: true,
    path: '/document-type/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/document_type/fiche')
    ),
  },
  {
    exact: true,
    path: '/document-type/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/document_type/fiche')
    ),
  },

  // Document type
  {
    exact: true,
    path: pageUrl.administration.settings.documentType,
    component: lazy(() =>
      import('../views/menu/administration/admin/document_type/table')
    ),
  },

  // Comment  Report
  {
    exact: true,
    path: pageUrl.administration.settings.commentReport,
    component: lazy(() =>
      import('../views/menu/administration/admin/commentReport/table/Index')
    ),
  },

  // group widget
  {
    exact: true,
    path: pageUrl.administration.settings.groupWidget,
    component: lazy(() =>
      import('../views/menu/administration/admin/group_widget/table/index')
    ),
  },
  {
    exact: true,
    path: '/group-widget/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/group_widget/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/group-widget/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/group_widget/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/group-widget/detail/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/group_widget/fiche/index')
    ),
  },
  // quality
  {
    exact: true,
    path: pageUrl.administration.settings.quality,
    component: lazy(() =>
      import('../views/menu/administration/admin/quality/table/index')
    ),
  },
  {
    exact: true,
    path: '/quality/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/quality/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/quality/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/quality/fiche/index')
    ),
  },

  // power_ebam
  {
    exact: true,
    path: pageUrl.administration.settings.powerEbam,
    component: lazy(() =>
      import('../views/menu/administration/admin/power_ebam/table/index')
    ),
  },
  {
    exact: true,
    path: '/power_ebam/new',
    component: lazy(() =>
      import('../views/menu/administration/admin/power_ebam/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/power_ebam/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/admin/power_ebam/fiche/index')
    ),
  },
  // #########################################################################################
  // #############                COMMUNICATION                    ###########################
  // #########################################################################################

  /// Fichier télétransmis
  {
    exact: true,
    path: pageUrl.administration.communication.exchangedFiles,
    component: lazy(() =>
      import(
        '../views/menu/administration/communication/fichier_teletransmis/table'
      )
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.communication.treatment,
    component: lazy(() =>
      import('../views/menu/administration/communication/post_traitement/table')
    ),
  },
  {
    exact: true,
    path: '/post_traitement/new',
    component: lazy(() =>
      import('../views/menu/administration/communication/post_traitement/fiche')
    ),
  },
  {
    exact: true,
    path: '/post_traitement/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/communication/post_traitement/fiche')
    ),
  },

  // Chiffrement
  {
    exact: true,
    path: pageUrl.administration.communication.encryption,
    component: lazy(() =>
      import(
        '../views/menu/administration/communication/chiffrement/table/index'
      )
    ),
  },
  {
    exact: true,
    path: '/encryption/new',
    component: lazy(() =>
      import(
        '../views/menu/administration/communication/chiffrement/fiche/index'
      )
    ),
  },
  {
    exact: true,
    path: '/encryption/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/communication/chiffrement/fiche/index'
      )
    ),
  },
  /// Fraud monitor
  {
    exact: true,
    path: pageUrl.administration.communication.fraudMonitor,
    component: lazy(() =>
      import('../views/menu/administration/communication/fraud-monitor/table')
    ),
  },
  {
    exact: true,
    path: '/fraud_monitor/new',
    component: lazy(() =>
      import(
        '../views/menu/administration/communication/fraud-monitor/fiche/index'
      )
    ),
  },
  {
    exact: true,
    path: '/fraud_monitor/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/communication/fraud-monitor/fiche/index'
      )
    ),
  },
  // connecteur
  {
    exact: true,
    path: pageUrl.administration.communication.connector,
    component: lazy(() =>
      import('../views/menu/administration/communication/connector/table')
    ),
  },
  {
    exact: true,
    path: '/connector/new',
    component: lazy(() =>
      import('../views/menu/administration/communication/connector/fiche')
    ),
  },
  {
    exact: true,
    path: '/connector/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/communication/connector/fiche')
    ),
  },
  {
    exact: true,
    path: '/frm_Service',
    component: lazy(() =>
      import('../views/menu/administration/communication/connector/services')
    ),
  },

  // #########################################################################################
  // #############                 INTERFACES                      ###########################
  // #########################################################################################
  // Flux
  {
    exact: true,
    path: pageUrl.administration.interface.flow,
    component: lazy(() =>
      import('../views/menu/administration/interfaces/flux/table/index')
    ),
  },
  {
    exact: true,
    path: '/flow/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/flux/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/flow/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/flux/fiche/index')
    ),
  },
  // imports
  {
    exact: true,
    path: pageUrl.administration.interface.import,
    component: lazy(() =>
      import('../views/menu/administration/interfaces/imports/table')
    ),
  },
  {
    exact: true,
    path: '/import_mapping/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/imports/fiche')
    ),
  },
  {
    exact: true,
    path: '/import_mapping/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/imports/fiche')
    ),
  },
  {
    exact: true,
    path: '/import_mapping/:id_interface_import/detail',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/imports/detail/table')
    ),
  },
  {
    exact: true,
    path: '/import_mapping/:id_interface_import/detail/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/imports/detail/fiche')
    ),
  },
  {
    exact: true,
    path: '/import_mapping/:id_interface_import/detail/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/imports/detail/fiche')
    ),
  },
  // exports
  {
    exact: true,
    path: pageUrl.administration.interface.export,
    component: lazy(() =>
      import('../views/menu/administration/interfaces/exports/table')
    ),
  },
  {
    exact: true,
    path: '/export_mapping/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/exports/fiche')
    ),
  },
  {
    exact: true,
    path: '/export_mapping/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/exports/fiche')
    ),
  },
  {
    exact: true,
    path: '/export_mapping/:id_interface_export/detail',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/exports/detail/table')
    ),
  },
  {
    exact: true,
    path: '/export_mapping/:id_interface_export/detail/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/exports/detail/fiche')
    ),
  },
  {
    exact: true,
    path: '/export_mapping/:id_interface_export/detail/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/exports/detail/fiche')
    ),
  },
  // formats
  {
    exact: true,
    path: pageUrl.administration.interface.format,
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/table')
    ),
  },
  {
    exact: true,
    path: '/format/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/fiche')
    ),
  },
  {
    exact: true,
    path: '/format/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/fiche')
    ),
  },
  {
    exact: true,
    path: '/format/:format_id/detail',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/detail/table')
    ),
  },
  {
    exact: true,
    path: '/format/:format_id/detail/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/detail/fiche')
    ),
  },
  {
    exact: true,
    path: '/format/:format_id/detail/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/detail/fiche')
    ),
  },
  {
    exact: true,
    path: '/format/:format_id/detail/:detail_format_id/items',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/rubrique/table')
    ),
  },
  {
    exact: true,
    path: '/format/:format_id/detail/:detail_format_id/items/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/rubrique/fiche')
    ),
  },
  {
    exact: true,
    path: '/format/:format_id/detail/:detail_format_id/items/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/formats/rubrique/fiche')
    ),
  },
  // règle d'import
  {
    exact: true,
    path: pageUrl.administration.interface.importRule,
    component: lazy(() =>
      import('../views/menu/administration/interfaces/import-rule/table')
    ),
  },
  {
    exact: true,
    path: '/import_rule/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/import-rule/fiche')
    ),
  },
  {
    exact: true,
    path: '/import_rule/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/import-rule/fiche')
    ),
  },
  // règle d'export
  {
    exact: true,
    path: pageUrl.administration.interface.exportRule,
    component: lazy(() =>
      import('../views/menu/administration/interfaces/export-rule/table')
    ),
  },
  {
    exact: true,
    path: '/export_rule/new',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/export-rule/fiche')
    ),
  },
  {
    exact: true,
    path: '/export_rule/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/interfaces/export-rule/fiche')
    ),
  },
  // #########################################################################################
  // #############                 CUSTOMISATION                   ###########################
  // ########################################################################################
  // listes
  {
    exact: true,
    path: pageUrl.administration.customization.list,
    component: lazy(() =>
      import('../views/menu/administration/customisation/listes/table')
    ),
  },
  {
    exact: true,
    path: '/customisation-list/new',
    component: lazy(() =>
      import('../views/menu/administration/customisation/listes/fiche')
    ),
  },
  {
    exact: true,
    path: '/customisation-list/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/customisation/listes/fiche')
    ),
  },
  {
    exact: true,
    path: '/customisation-list/:list_id/detail',
    component: lazy(() =>
      import('../views/menu/administration/customisation/listes/detail/table')
    ),
  },
  {
    exact: true,
    path: '/customisation-list/:list_id/detail/new',
    component: lazy(() =>
      import('../views/menu/administration/customisation/listes/detail/fiche')
    ),
  },
  {
    exact: true,
    path: '/customisation-list/:list_id/detail/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/customisation/listes/detail/fiche')
    ),
  },
  // Accounting field
  {
    exact: true,
    path: pageUrl.administration.customization.accountingField,
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/accounting-field/table'
      )
    ),
  },
  {
    exact: true,
    path: '/customisation-accounting-field/new',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/accounting-field/fiche'
      )
    ),
  },
  {
    exact: true,
    path: '/customisation-accounting-field/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/accounting-field/fiche'
      )
    ),
  },
  // dynamic method
  {
    exact: true,
    path: pageUrl.administration.customization.method,
    component: lazy(() =>
      import('../views/menu/administration/customisation/dynamic-method/table')
    ),
  },
  {
    exact: true,
    path: '/dynamic_method/new',
    component: lazy(() =>
      import('../views/menu/administration/customisation/dynamic-method/fiche')
    ),
  },
  {
    exact: true,
    path: '/dynamic_method/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/customisation/dynamic-method/fiche')
    ),
  },
  // tiers
  {
    exact: true,
    path: pageUrl.administration.customization.thirdParty,
    component: lazy(() =>
      import('../views/menu/administration/customisation/tiers/table')
    ),
  },
  {
    exact: true,
    path: '/custom/new',
    component: lazy(() =>
      import('../views/menu/administration/customisation/tiers/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/custom/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/customisation/tiers/fiche/index')
    ),
  },

  // Correspondances
  {
    exact: true,
    path: pageUrl.administration.customization.correspondence,
    component: lazy(() =>
      import('../views/menu/administration/customisation/correspondance/table')
    ),
  },
  {
    exact: true,
    path: '/frm_Correspondance/new',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/correspondance/fiche/index'
      )
    ),
  },

  {
    exact: true,
    path: '/frm_Correspondance/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/correspondance/fiche/index'
      )
    ),
  },

  // Details correspondance
  {
    exact: true,
    path: '/frm_Correspondance/detail/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/correspondance/table-champs'
      )
    ),
  },
  {
    exact: true,
    path: '/frm_Correspondance/detail/:id/new',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/correspondance/fiche-champs/index'
      )
    ),
  },

  {
    exact: true,
    path: '/frm_Correspondance/detail/:id/edit/:idDetail',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/correspondance/fiche-champs/index'
      )
    ),
  },
  // template email
  {
    exact: true,
    path: pageUrl.administration.customization.emailTemplate,
    component: lazy(() =>
      import('../views/menu/administration/customisation/template-email/table')
    ),
  },
  {
    exact: true,
    path: '/email_template/new',
    component: lazy(() =>
      import('../views/menu/administration/customisation/template-email/fiche')
    ),
  },
  {
    exact: true,
    path: '/email_template/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/customisation/template-email/fiche')
    ),
  },
  // email rule
  {
    exact: true,
    path: pageUrl.administration.customization.emailRule,
    component: lazy(() =>
      import('../views/menu/administration/customisation/email-rule/table')
    ),
  },

  {
    exact: true,
    path: '/notification_rule/new',
    component: lazy(() =>
      import('../views/menu/administration/customisation/email-rule/fiche')
    ),
  },
  {
    exact: true,
    path: '/notification_rule/edit/:id',
    component: lazy(() =>
      import('../views/menu/administration/customisation/email-rule/fiche')
    ),
  },

  // email State rule
  {
    exact: true,
    path: pageUrl.administration.customization.emailStateRule,
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/state-email-rule/table/index'
      )
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.customization.newEmailStateRule,
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/state-email-rule/fiche/index'
      )
    ),
  },
  {
    exact: true,
    path: '/scheduled_task/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/state-email-rule/fiche/index'
      )
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.customization.fieldMask,
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/custom-field/table/index'
      )
    ),
  },
  {
    exact: true,
    path: '/frm_MasqueChamp/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/custom-field/fiche/index'
      )
    ),
  },
  {
    exact: true,
    path: '/frm_MasqueChamp/create-custom-field',
    component: lazy(() =>
      import(
        '../views/menu/administration/customisation/custom-field/fiche/index'
      )
    ),
  },
  // #########################################################################################
  // #############                 AUDIT                           ###########################
  // #########################################################################################

  /// connexion
  {
    exact: true,
    path: pageUrl.administration.audit.connection,
    component: lazy(() =>
      import('../views/menu/administration/audit/connexion/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.audit.service,
    component: lazy(() =>
      import('../views/menu/administration/audit/services/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.audit.hash_file,
    component: lazy(() =>
      import('../views/menu/administration/audit/hash-file/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.audit.histo_api,
    component: lazy(() =>
      import('../views/menu/administration/audit/histo-call-api/table/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.administration.audit.gdpr,
    component: lazy(() =>
      import('../views/menu/administration/audit/gdpr/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.audit.historyFiles,
    component: lazy(() =>
      import('../views/menu/administration/audit/history-file/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.audit.trustedThirdParty,
    component: lazy(() =>
      import('../views/menu/administration/audit/trusted-third-party/table/index')
    ),
  },

  // EBAM
  {
    exact: true,
    path: pageUrl.administration.ebam.liste,
    component: lazy(() =>
      import('../views/menu/administration/admin/codeEbam/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.ebam.new,
    component: lazy(() =>
      import('../views/menu/administration/admin/codeEbam/fiche/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.administration.ebam.edit,
    component: lazy(() =>
      import('../views/menu/administration/admin/codeEbam/fiche/index')
    ),
  },
];
